import type {
    CreatureSpeedEchoSuppressionInput,
    CreatureSpeedEchoSuppressionResult,
    EchoSuppressibleSpeedName,
} from '../types';

export const ECHO_SUPPRESSIBLE_SPEEDS = [
    'swimming', 'climbing', 'flying', 'burrowing', 'hovering',
] as const satisfies readonly EchoSuppressibleSpeedName[];

/**
 * Remove status-generated speed echoes that equal jump on a creature which had no
 * corresponding speed layer before statuses were applied.
 */
export function suppressCreatureSpeedEchoes(input: CreatureSpeedEchoSuppressionInput): CreatureSpeedEchoSuppressionResult {
    const totals = Object.fromEntries(
        ECHO_SUPPRESSIBLE_SPEEDS.map((speed) => [speed, input.totals[speed] ?? 0]),
    ) as Record<EchoSuppressibleSpeedName, number>;
    const suppressed: EchoSuppressibleSpeedName[] = [];

    if (
        input.preStatusPresence !== null
        && input.walkTotal > 0
        && input.jumpTotal > 0
        && input.jumpTotal !== input.walkTotal
    ) {
        for (const speed of ECHO_SUPPRESSIBLE_SPEEDS) {
            if (input.preStatusPresence[`speed_${speed}`]) {
                continue;
            }
            if (totals[speed] === input.jumpTotal) {
                totals[speed] = 0;
                suppressed.push(speed);
            }
        }
    }

    return { totals, suppressed };
}
